import { TemplateIds } from './presetTemplates';

/**
 * Legacy Layout Type Mapping
 * Maps legacy fit and layout types to new LayoutTemplate IDs
 */

/**
 * Fit and Layout type identifiers used in the UI
 */
export enum FitType {
  Cover = 'cover',
  Contain = 'contain',
  Fill = 'fill',
  BlurredBackground = 'blurred-background',
  Stacked1To1 = 'stacked-1-1',
  Stacked1To3 = 'stacked-1-3',
  SplitVertical = 'split_vertical',
}

const FIT_TO_TEMPLATE_MAP: Record<string, string> = {
  [FitType.Cover]: TemplateIds.Cover,
  [FitType.Contain]: TemplateIds.Contain,
  [FitType.Fill]: TemplateIds.Fill,
  [FitType.BlurredBackground]: TemplateIds.BlurredBackground,
  [FitType.Stacked1To1]: TemplateIds.SplitHorizontal,
  [FitType.Stacked1To3]: TemplateIds.Stacked1To3,
};

/**
 * Maps any fit or layout type to corresponding LayoutTemplate ID
 * @param fitOrLayoutType - Fit type ('cover', 'contain', 'fill') or layout type ('stacked-1-1', 'stacked-1-3')
 * @returns Template ID for the corresponding layout template
 */
export function mapFitTypeToTemplateId(fitOrLayoutType: string): string {
  return FIT_TO_TEMPLATE_MAP[fitOrLayoutType] ?? TemplateIds.Cover;
}

const TEMPLATE_TO_FIT_MAP: Record<string, string> = {
  [TemplateIds.Cover]: FitType.Cover,
  [TemplateIds.Contain]: FitType.Contain,
  [TemplateIds.Fill]: FitType.Fill,
  [TemplateIds.BlurredBackground]: FitType.BlurredBackground,
  [TemplateIds.SplitHorizontal]: FitType.Stacked1To1,
  [TemplateIds.Stacked1To3]: FitType.Stacked1To3,
  [TemplateIds.SplitVertical]: FitType.SplitVertical,
};

/**
 * Extracts fit type from template ID
 * @param templateId - Template ID (e.g., 'cover', 'split_horizontal', 'stacked_horizontal_1_3')
 * @returns Fit or layout type string
 */
export function extractFitTypeFromTemplateId(templateId: string): string {
  return TEMPLATE_TO_FIT_MAP[templateId] ?? FitType.Cover;
}
